import React, { useEffect } from 'react';
import { checkSession } from './admin/checkSession';
import CoinhouseSolutionsAdmin from "./admin";


const App = () => {
    useEffect(() => {
        checkSession();    
        // Vérif toutes les 5 minutes
        const interval = setInterval(() => {
          checkSession();
        }, 5 * 60 * 1000); 
        return () => clearInterval(interval);
      }, []);
  return (
      <CoinhouseSolutionsAdmin />
  );
};

export default App;